// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__HsBPE","title":"styles_title__pFrcV","description":"styles_description__EZIbK"};